import React, { useContext } from "react";
import Header from "../../../Navs/Header";
import NavBarVerticalV2 from "../../navbarVerticalV2/navbarVerticalV2";
import * as IconlyPack from "react-iconly";
import { DataContext } from "../../../store/GlobalState";
import FamilleSoinsTable from "../../../Tables/FamiileSoins/FamilleSoinsTable";
import AddFamilleSoinModal from "../../../Modals/AddFamilleSoinModal";
import UseCreateFamilleSoinForm from "./UseCreateFamilleSoinForm";

const GestionFamilleSoin = () => {
  const {
    register,
    formState,
    isSuccessfullySubmitted,
    setIsSuccessfullySubmitted,
    setIsFormRequestError,
    isFormRequestError,
    clearErrors,
    onSubmit,
    reset,
    setValue,
  } = UseCreateFamilleSoinForm();
  return (
    <div className="dashboard-item-container">
      <div className="container-fluid body-background-dashboard">
        <Header />
        <div className="row">
          {/* Navbar Desktop  */}
          <div className="nav-container">
            <NavBarVerticalV2 />
          </div>
          <div className="offset-xl-1 offset-lg-1 col-xl-11 col-lg-11 col-md-12 content-position-after-header px-md-3 px-0 beny">
            <div className="page-body-container">
              <div className="page-content-container">
                <div className="page-first-row-container">
                  <div className="page-title-container">
                    <h1 className="page-title">
                      Familles de soins &nbsp;
                      {/* <span className="badge badge-info easypm-badge-info">
                      </span> */}
                    </h1>
                  </div>
                  <div
                    className="adding-item-container linkable"
                    data-toggle="modal"
                    data-target=".add-familleSoin-modal"
                  >
                    <span className="icon-container">
                      <IconlyPack.Plus set="light" primaryColor="gray" />
                    </span>
                    <span className="adding-item-label">
                      Ajouter une famille de soins
                    </span>
                  </div>
                </div>
                <div className="parent-table-container">
                  <FamilleSoinsTable />
                </div>
                {/* Modal */}
                <div
                  className="modal fade easypm-modal add-familleSoin-modal"
                  id="AddFamilleSoinModalItem2"
                  tabIndex="-1"
                  aria-labelledby="AddFamilleSoinModalItem2Label"
                  aria-hidden="true"
                  data-backdrop="static"
                >
                  <AddFamilleSoinModal
                    register={register}
                    onSubmit={onSubmit}
                    formState={formState}
                    isSuccessfullySubmitted={isSuccessfullySubmitted}
                    setIsSuccessfullySubmitted={setIsSuccessfullySubmitted}
                    reset={reset}
                    setValue={setValue}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GestionFamilleSoin;
